import { render, staticRenderFns } from "./servico-editar.vue?vue&type=template&id=5b938ff2&"
import script from "./servico-editar.vue?vue&type=script&lang=js&"
export * from "./servico-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports